/**
 * The Tasks4Staff product mark, beside the product name (`feat-product-logo-favicon`).
 *
 * The same file the tab shows as its icon — `/favicon.svg`, served from `public/`, which
 * `pnpm brand:generate` writes from `@t4s/ui/brand`. It is referenced by URL rather than
 * imported: this application's import list from `@t4s/ui` is deliberately one function
 * (`docs/DECISIONS.md`, "The platform admin has no design system, no per-tenant theme and
 * one language"), and a static file
 * needs no import.
 *
 * Decorative (`alt=""`): it always sits next to the product name in text, so a screen
 * reader announcing it would say the name twice.
 */
export const BRAND_MARK_SRC = '/favicon.svg'

export function BrandMark({ size }: { readonly size: number }) {
  return (
    <img
      alt=""
      className="brand-mark"
      data-testid="brand-mark"
      height={size}
      src={BRAND_MARK_SRC}
      width={size}
    />
  )
}
